module.exports = __webpack_public_path__ + "static/media/skip-tile.589b95bf.svg";